import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';

// project-imports
import Palette from './palette';
import Typography from './typography';
import CustomShadows from './shadows';
import componentsOverride from './overrides';
import defaultConfig, { HEADER_HEIGHT, ThemeMode } from 'config';

// ==============================|| FIXED THEME — PUBLIC CMS ROUTES ||============================== //

/** Same defaults as shipped `config`, ignoring persisted user theme settings. */
export default function createPublicDefaultTheme(): Theme {
  const themeMode = ThemeMode.LIGHT;
  const theme = Palette(themeMode, defaultConfig.presetColor, defaultConfig.themeContrast);
  const themeTypography = Typography(defaultConfig.fontFamily);
  const themeCustomShadows = CustomShadows(theme);

  const themeOptions: ThemeOptions = {
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1024,
        lg: 1266,
        xl: 1440
      }
    },
    direction: defaultConfig.themeDirection,
    mixins: {
      toolbar: {
        minHeight: HEADER_HEIGHT,
        paddingTop: 8,
        paddingBottom: 8
      }
    },
    palette: theme.palette,
    shape: {
      borderRadius: 8
    },
    customShadows: themeCustomShadows,
    typography: themeTypography
  };

  const themes = createTheme(themeOptions);
  themes.components = componentsOverride(themes);
  return themes;
}
